import { Navigate } from 'react-location';

import { Page } from 'types/page';

import {
  MagicMovieAdditionalResources,
  MagicMovieChallenge,
  MagicMovieChooseUserName,
  MagicMovieColdStart,
  MagicMovieHowToPlay,
  MagicMovieIntro,
  MagicMovieMovieGrid,
  MagicMovieScenario,
} from './magicMovie';

/**
 * All pages for AwsHowserPortal
 **/
export enum AwsHowserPage {
  DEFAULT = 'MagicMovie',
  MAGIC_MOVIE_ADDITIONAL_RESOURCES = 'MagicMovieAdditionalResources',
  MAGIC_MOVIE_CHALLENGE = 'MagicMovieChallenge',
  MAGIC_MOVIE_COLD_START = 'MagicMovieColdStart',
  MAGIC_MOVIE_HOW_TO_PLAY = 'MagicMovieHowToPlay',
  MAGIC_MOVIE_INTRO = 'MagicMovieIntro',
  MAGIC_MOVIE_GRID = 'MagicMovieGrid',
  MAGIC_MOVIE_SCENARIO = 'MagicMovieScenario',
  MAGIC_MOVIE_USER_NAME = 'MagicMovieUserName',
}

interface PageRouteParams extends AwsHowserRouteParams {
  [AwsHowserPage.MAGIC_MOVIE_ADDITIONAL_RESOURCES]: null;
  [AwsHowserPage.MAGIC_MOVIE_CHALLENGE]: null;
  [AwsHowserPage.MAGIC_MOVIE_COLD_START]: null;
  [AwsHowserPage.MAGIC_MOVIE_HOW_TO_PLAY]: null;
  [AwsHowserPage.MAGIC_MOVIE_INTRO]: null;
  [AwsHowserPage.MAGIC_MOVIE_GRID]: null;
  [AwsHowserPage.MAGIC_MOVIE_SCENARIO]: null;
  [AwsHowserPage.MAGIC_MOVIE_USER_NAME]: null;
}

type PageCatalog = {
  [Key in AwsHowserPage]: Page<PageRouteParams[Key]>;
};

type AwsHowserRouteParams = {
  [Key in AwsHowserPage]: string | null;
};

const pageCatalog: PageCatalog = {
  [AwsHowserPage.MAGIC_MOVIE_ADDITIONAL_RESOURCES]: new Page({
    component: <MagicMovieAdditionalResources />,
    route: '/magicMovieAdditionalResources',
  }),
  [AwsHowserPage.MAGIC_MOVIE_CHALLENGE]: new Page({
    component: <MagicMovieChallenge />,
    route: '/magicMovieChallenge',
  }),
  [AwsHowserPage.MAGIC_MOVIE_COLD_START]: new Page({
    component: <MagicMovieColdStart />,
    route: '/magicMovieColdStart',
  }),
  [AwsHowserPage.MAGIC_MOVIE_HOW_TO_PLAY]: new Page({
    component: <MagicMovieHowToPlay />,
    route: '/magicMovieHowToPlay',
  }),
  [AwsHowserPage.MAGIC_MOVIE_INTRO]: new Page({
    component: <MagicMovieIntro />,
    route: '/',
  }),
  [AwsHowserPage.MAGIC_MOVIE_GRID]: new Page({
    component: <MagicMovieMovieGrid />,
    route: '/magicMovieGrid',
  }),
  [AwsHowserPage.MAGIC_MOVIE_SCENARIO]: new Page({
    component: <MagicMovieScenario />,
    route: '/magicMovieScenario',
  }),
  [AwsHowserPage.MAGIC_MOVIE_USER_NAME]: new Page({
    component: <MagicMovieChooseUserName />,
    route: '/magicMovieUserName',
  }),
  [AwsHowserPage.DEFAULT]: new Page({
    component: <Navigate to={`/`} />, // When going to a route without a path, default is the landing page
    route: '*',
  }),
};

export default pageCatalog;
